import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  plan: 'AirPack Esencial' | 'AirPack Completo';
  minutesAgo: number;
}
const PURCHASES: Purchase[] = [{
  name: 'Luca Gómez',
  city: 'Buenos Aires',
  plan: 'AirPack Completo',
  minutesAgo: 2
}, {
  name: 'Marcos Fernández',
  city: 'Córdoba',
  plan: 'AirPack Completo',
  minutesAgo: 4
}, {
  name: 'Juana Méndez',
  city: 'Rosario',
  plan: 'AirPack Esencial',
  minutesAgo: 7
}, {
  name: 'Ana Fontana',
  city: 'Mendoza',
  plan: 'AirPack Completo',
  minutesAgo: 10
}, {
  name: 'Lautaro Converso',
  city: 'La Plata',
  plan: 'AirPack Completo',
  minutesAgo: 13
}, {
  name: 'Micaela Pertes',
  city: 'Tucumán',
  plan: 'AirPack Completo',
  minutesAgo: 16
}, {
  name: 'Santino González',
  city: 'Mar del Plata',
  plan: 'AirPack Esencial',
  minutesAgo: 19
}, {
  name: 'Juan Deustch',
  city: 'Salta',
  plan: 'AirPack Completo',
  minutesAgo: 22
}, {
  name: 'Camila Sosa',
  city: 'Neuquén',
  plan: 'AirPack Completo',
  minutesAgo: 26
}, {
  name: 'Tomás Ibáñez',
  city: 'Bahía Blanca',
  plan: 'AirPack Esencial',
  minutesAgo: 30
}];
const SHOW_AFTER_MS = 6000; // first notification after 6s
const VISIBLE_MS = 5500; // each shown for 5.5s
const GAP_MS = 9000; // gap between notifications
const DISMISS_COOLDOWN_MS = 45000; // if user closes one, pause for 45s
function initialsOf(name: string) {
  return name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
}
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  const [index, setIndex] = useState(0);
  const [dismissedUntil, setDismissedUntil] = useState(0);
  useEffect(() => {
    let visibilityTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const showNext = () => {
      if (Date.now() < dismissedUntil) {
        nextTimer = setTimeout(showNext, 2000);
        return;
      }
      const p = PURCHASES[index % PURCHASES.length];
      setCurrent(p);
      setIndex(i => i + 1);
      visibilityTimer = setTimeout(() => {
        setCurrent(null);
        nextTimer = setTimeout(showNext, GAP_MS);
      }, VISIBLE_MS);
    };
    const startTimer = setTimeout(showNext, SHOW_AFTER_MS);
    return () => {
      clearTimeout(startTimer);
      clearTimeout(visibilityTimer);
      clearTimeout(nextTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDismiss = () => {
    setCurrent(null);
    setDismissedUntil(Date.now() + DISMISS_COOLDOWN_MS);
  };
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none" data-id="element-230">
      <AnimatePresence data-id="element-231">
        {current && <motion.div key={`${current.name}-${index}`} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 26
      }} className="pointer-events-auto bg-white border border-sand rounded-xl shadow-2xl pl-3 pr-8 py-3 flex items-center gap-3 max-w-[320px] relative" role="status" aria-live="polite" data-id="element-232">
            <div className="relative flex-shrink-0" data-id="element-233">
              <div className="w-10 h-10 rounded-full bg-ember/10 text-ember flex items-center justify-center font-bold text-sm" data-id="element-234">
                {initialsOf(current.name)}
              </div>
              <CheckCircle2 size={14} className="absolute -bottom-0.5 -right-0.5 text-green-600 bg-white rounded-full" fill="white" data-id="element-235" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-236">
              <p className="text-[13px] text-charcoal/90 leading-snug" data-id="element-237">
                <span className="font-bold" data-id="element-238">{current.name}</span> de{' '}
                <span className="font-semibold" data-id="element-239">{current.city}</span> compró{' '}
                <span className="font-bold text-ember" data-id="element-240">{current.plan}</span>
              </p>
              <p className="text-[11px] text-charcoal/50 mt-0.5 font-medium" data-id="element-241">
                hace {current.minutesAgo} min · ✅ Compra verificada
              </p>
            </div>
            <button type="button" onClick={handleDismiss} aria-label="Cerrar notificación" className="absolute top-1.5 right-1.5 text-charcoal/30 hover:text-charcoal/70 transition-colors p-1" data-id="element-242">
              <X size={14} data-id="element-243" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}